import s from './style.css';
import cn from 'classnames';
import LineWrapper from 'components/LineWrapper';
import TextWithBackground from 'components/TextWithBackground';

const TextComparison = ({ items, smallAtMobile = true }) => (
	<LineWrapper
		plain
		tight
		snugPadding
		className={cn(s.compare, { [s.smallAtMobile]: smallAtMobile })}
	>
		{items.map((text, i) => (
			<TextWithBackground
				bg="transparent"
				className={cn(s.compareFact, { [s.compareFactEven]: !(i % 2) })}
			>
				{text}
			</TextWithBackground>
		))}
	</LineWrapper>
);

export default TextComparison;



// WEBPACK FOOTER //
// ./components/TextComparison/index.js